define(['jquery'], function ($) {

  $.fn.escape = function (options) {
    var special = [8, 9, 13, 36, 35, 37, 38, 39, 40, 46, 116];

    function init(elem) {

      $(elem).keypress(function (e) {
        var key = e.keyCode,
          cc = e.charCode || e.keyCode;
        if ($.inArray(key, special) < 0) {
          if (!String.fromCharCode(cc).match(options)) {
            return false;
          }
        }
      });

    }

    return this.each(function () {
      init(this);
    });
  };

});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/lib/jquery.pkoEscape.js